<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeIntegrations/">Channels</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeConnections/">Create Channel</a></li>
      <li class="breadcrumb-item active" aria-current="page">Woocommerce</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box p-4">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Channel Name</label>
              <input type="text" id="channelName" class="form-control" (blur)="typechannelName()"
                     [ngClass]="{'is-invalid':statusText22}" [(ngModel)]="channelName"
                     [ngModelOptions]="{standalone: true}" placeholder="Channel name" required>
              <div id="statusText22" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText22"
                   style="position: absolute;">
                {{statusText22}}
              </div>
            </div>
            <div class="form-group ">
              <label class="control-label" for="storeId">Host Name</label>
              <div class="row">
                <div class="col-4 pr-1">
                  <select id="perfix" [(ngModel)]="hostNamePrefix" class="form-control"
                          [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let prefix of ['https://','http://']" [ngValue]="prefix">
                      {{prefix}}
                    </option>
                  </select>
                </div>
                <div class="col-8 pl-1">
                  <input type="text" id="storeId" class="form-control" (blur)="typeHostName()"
                         [ngClass]="{'is-invalid':statusText2}" [(ngModel)]="hostName"
                         [ngModelOptions]="{standalone: true}" placeholder="Host name" required>
                  <div id="statusText2" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2"
                       style="position: absolute;">
                    {{statusText2}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">Client Id</label>
              <input type="text" id="apiKey" class="form-control" (blur)="typeApiKey()"
                     [ngClass]="{'is-invalid':statusText11}" [(ngModel)]="apiKey" [ngModelOptions]="{standalone: true}"
                     placeholder="API Key" required>
              <div id="statusText11" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText11"
                   style="position: absolute;">
                {{statusText11}}
              </div>
            </div>
            <div class="form-group">
              <label class="control-label" for="password">Client Secret</label>
              <input type="password" id="password" class="form-control" (blur)="typePassword()"
                     [ngClass]="{'is-invalid':statusText1}" [(ngModel)]="passWord" [ngModelOptions]="{standalone: true}"
                     placeholder="********" required>
              <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1"
                   style="position: absolute;">
                {{statusText1}}
              </div>
            </div>

          </div>
          <div class="col-md-3">
            <label>&nbsp;</label>
            <div class="upload-box" *ngIf="!imageUrl">
              <input type="file" (change)="loadImage($event)">
              <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                      d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
              </svg>
              <div>upload logo</div>
            </div>
            <div class="upload-box mt-2" *ngIf="imageUrl">
              <img class="shift-uploaded-img shift-image"
                   src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                   width="250" height="250"/>
              <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
              <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img"
                   src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                   width="150" height="150"/>
              <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img"
                   src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                   width="100" height="100"/>
              <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img"
                   src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                   width="50" height="50"/>
              <div class="overly">
                <button class="btn" id="upload">Upload</button>
                <button class="btn" id="remove">Remove</button>
              </div>
            </div>
          </div>
          <div class="col-md-3 align-self-end">
            <div class="instr-box">
              <span>Woo Commerce Market Place Instructions </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="17.14" height="17.14" viewBox="0 0 17.14 17.14">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                      d="M17.7,9.132A8.57,8.57,0,1,1,9.132.563,8.569,8.569,0,0,1,17.7,9.132ZM9.362,3.4A4.476,4.476,0,0,0,5.335,5.6a.415.415,0,0,0,.094.562l1.2.909A.415.415,0,0,0,7.2,7c.617-.783,1.041-1.237,1.98-1.237.706,0,1.579.454,1.579,1.139,0,.518-.427.783-1.124,1.174C8.826,8.529,7.75,9.1,7.75,10.515v.138a.415.415,0,0,0,.415.415H10.1a.415.415,0,0,0,.415-.415v-.046c0-.984,2.875-1.024,2.875-3.686C13.389,4.916,11.31,3.4,9.362,3.4Zm-.23,8.57a1.59,1.59,0,1,0,1.59,1.59A1.591,1.591,0,0,0,9.132,11.966Z"
                      transform="translate(-0.563 -0.563)" fill="#c1c1c1"/>
              </svg>
            </div>
            <button class="btn btn-orange btn-block" id="test" (click)="verify()">Test Connection & Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
